import React from "react";
import { ProgramsGrid } from "@/components/sections/ProgramsGrid";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { CTABand } from "@/components/sections/CTABand";

export default function ProgramsPage() {
  return (
    <main>
      <PageHeader eyebrow="Programs" title="12 focused programs, one mission." lead="Each program has a named lead, a published scope, and quarterly outcome tracking." />
      <ProgramsGrid />
      <CTABand />
    </main>
  );
}
